export const reasons = [
  {
    id: 1,
    name: "Amount spent",
  },
  {
    id: 7,
    name: "Asked for information on self-exclusion",
  },
  {
    id: 4,
    name: "Change in behaviour ",
  },
  {
    id: 8,
    name: "Suspect borrowing money to gamble",
  },
  {
    id: 2,
    name: "Time at machine / at venue",
  },
  {
    id: 5,
    name: "Visible signs of stress or distress",
  },
  {
    id: 3,
    name: "Visiting the ATM regularly",
  },
  {
    id: 6,
    name: "Vulnerable person – physical, impaired or showing signs of stress",
  },
];

export const outcomes = [
  {
    id: 1,
    name: "Customer agreed to set a time and spend limit",
  },
  {
    id: 6,
    name: "Customer agreed to take a longer break from gambling",
  },
  {
    id: 5,
    name: "Customer agreed to take a short break",
  },
  {
    id: 7,
    name: "Customer barred for a period of time",
  },
  {
    id: 2,
    name: "Customer moved to a lower stake",
  },
  {
    id: 3,
    name: "Customer was fine and seems in control of their gambling",
  },
  {
    id: 4,
    name: "Other (details entered of the other type of outcome) ",
  },
];

export const actions = [
  { id: 1, name: "Offered to set a time and spend limit" },
  { id: 2, name: "Offered for them to take a break" },
  { id: 3, name: "Conducted a welfare check" },
  { id: 4, name: "Offered self-exclusion" },
  { id: 5, name: "Asked for them to leave the venue" },
];

export const defaultInteractionOptions = { outcomes, reasons, actions };
